import React, {useReducer} from 'react';

import {AppContext} from "./appContext";
import {appReducer} from "./appReducer";


const init = () => {
    return {
        logged: false,
        name: '',
        load: false,
        submenu: "",
        consultar: 0,
        editar: 0,
        eliminar: 0,
        adicionar: 0,
        contratomarcoId: null,
        showMenu: false
    }
}

export const Provider = ({children}) => {
    const [user, dispatch] = useReducer(appReducer, {}, init)
    return (
        <AppContext.Provider value={{
            user,
            dispatch
        }
        }>
            {children}
        </AppContext.Provider>
    );
}
